export function addAnchorAttributesInHTML(body: string): string {
    return body.replace(/<a\s(.*?)>(.|\n)*?<\/a>/g, (match, p1) => {
        let attr: string = p1.replace(/\starget=".*?"/, '');
        attr = attr.replace(/\srel=".*?"/, '');

        return match.replace(p1, `${attr} target="_blank" rel="noopener noreferrer"`);
    });
}
